import React from 'react';
import TrendBase from '../components/trend/trendBase';

const Customer = () => {
  return <TrendBase source='customer' />;
};

export default Customer;
